import {Component} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'eula',    
    template: require('.//eula.component.html'), 
   
})

export class EulaComponent{
    


}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/eula/eula.component.ts
 **/